// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__92Q0i","loader":"Loader_loader__Bb_wO","loadingio":"Loader_loadingio__1uKg0"};